export enum ForecastDaysMode {
	Days7 = 'days7',
	Days10 = 'days10',
}

export const defaultForecastDaysMode = ForecastDaysMode.Days7;

export const daysModeMaximumDaysCount = 10;

export const dayMiddleHour = 14;
